import { TAO_KOE } from './../libs';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';

/**
 * BlogList class.
 *
 * @param {HTMLElement} el - The element that will contain the blog list.
 * @return {void} This function does not return a value.
 */
const BlogList = function( el ) {
	const self = this;
	this.el = el;

	this.selectedFilters = {
		type: '',
		standort: '',
		bereich: '',
	};

	this.isoElement = self.initIsotope();

	setTimeout( () => {
		this.isoElement.layout();
	}, 100 );

	imagesLoaded( this.isoElement ).on( 'progress', () => {
		this.isoElement.layout();
	} );

	self.filter();

	// Check if Element becomes visible, if yes, then rearrange.
	this.observer = new IntersectionObserver( ( entries ) => {
		entries.forEach( ( entry ) => {
			// Check if entry is visible.
			if ( entry.isIntersecting && entry.target.checkVisibility() ) {
				this.isoElement.layout();
			}
		} );
	}, {
		root: null,
		rootMargin: '100px 50px 250px 50px',
		threshold: 0,
	} );
	this.observer.observe( this.el );
};

/**
 * Initializes the Isotope layout for the BlogList.
 *
 * @return {Isotope} The initialized Isotope instance.
 */
BlogList.prototype.initIsotope = function() {
	return new Isotope( this.el, {
		itemSelector: '.en_mdl_blog_list_item',
		filter: ( itemElem1, itemElem2 ) => {
			const itemElem = itemElem1 || itemElem2;

			const typeResult = this.isSelected( this.selectedFilters.type, itemElem.dataset.taoFilterType );
			const standortResult = this.isSelected( this.selectedFilters.standort, itemElem.dataset.taoFilterStandort );
			const bereichResult = this.isSelected( this.selectedFilters.bereich, itemElem.dataset.taoFilterBereich );

			return typeResult && standortResult && bereichResult;
		},
		percentPosition: true,
		masonry: {
			horizontalOrder: true,
		},
	} );
};

/**
 * Checks whether the given filter is set in the attribute list of the element.
 *
 * @param {string}       filter        The string to check.
 * @param {string|Array} attributeList List of Attributes, divided by semicolon.
 * @return {boolean} Whether the Filter is included in the AttributeList
 */
BlogList.prototype.isSelected = function( filter, attributeList ) {
	if ( ! filter ) {
		return true;
	}

	return [].concat( attributeList ).join( ';' ).split( ';' ).includes( filter );
};

/**
 * Filters the blog list based on the selected filters.
 * And stores the filter value in selectedFilters.
 *
 * @return {void} This function does not return a value.
 */
BlogList.prototype.filter = function() {
	const taoFilter = document.querySelector( '.tao-filter' );

	// Return if there is no filters for joblist.
	if ( ! taoFilter ) {
		return;
	}

	const selectFilters = taoFilter.querySelectorAll( '.en_select select' );

	/**
	 * Function to trigger a filter based on a selected option.
	 *
	 * @param {Object} selectFilter - The select filter object
	 * @return {void}
	 */
	const triggerFilter = ( selectFilter ) => {
		const opt = getSelectedOption( selectFilter );
		this.selectedFilters[ selectFilter.id ] = opt.value;
		this.isoElement.arrange();

		const emptyElem = document.querySelector( '.en_mdl_blog_list_empty' );
		emptyElem.classList.toggle( 'en_hidden', this.isoElement.getFilteredItemElements().length !== 0 );
	};

	if ( selectFilters.length > 0 ) {
		selectFilters.forEach( ( selectFilter ) => {
			// Immediately apply filter and layout adjustments based on the current selection.
			triggerFilter( selectFilter );

			// Listen for any change events on each select filter element.
			selectFilter.addEventListener( 'change', ( event ) => {
				triggerFilter( event.target );
			} );
		} );
	}

	/**
	 * Returns the selected option from a select element.
	 *
	 * @param {HTMLSelectElement} sel - The select element.
	 * @return {HTMLOptionElement} The selected option.
	 */
	function getSelectedOption( sel ) {
		let opt;
		for ( let i = 0, len = sel.options.length; i < len; i++ ) {
			opt = sel.options[ i ];
			if ( opt.selected === true ) {
				break;
			}
		}
		return opt;
	}
};

/**
 * Initializes the BlogList.
 *
 * @param {Element} scopeEl The scope Element to look for lists we can initialize.
 * @return {void} This function does not return a value.
 */
BlogList.init = function( scopeEl = document ) {
	const blogpostListEls = scopeEl.querySelectorAll( '.en_mdl_blog_list_items' );
	blogpostListEls.forEach( ( blogpostListEl ) => {
		blogpostListEl.KOE_BlogList ??= new BlogList( blogpostListEl );
	} );
};

TAO_KOE.ready( 'blogposts.js', () => BlogList.init() );

// Expose.
TAO_KOE.BlogList = BlogList;

export default BlogList;
